import { gql } from '@apollo/client';
import { UserListInfoShared } from '../fragments';

export default gql`
  query users(
    $partnerOrganizationId: ID
    $partnerLocationId: [ID!]
    $accountId: ID
    $state: [String!]
    $withoutPlan: Boolean
    $imported: Boolean
    $lastLoginAtStart: String
    $lastLoginAtEnd: String
    $createdAtStart: String
    $createdAtEnd: String
    $limit: Int
    $offset: Int
  ) {
    users(
      partnerOrganizationId: $partnerOrganizationId
      partnerLocationId: $partnerLocationId
      accountId: $accountId
      state: $state
      withoutPlan: $withoutPlan
      imported: $imported
      lastLoginAtStart: $lastLoginAtStart
      lastLoginAtEnd: $lastLoginAtEnd
      createdAtStart: $createdAtStart
      createdAtEnd: $createdAtEnd
      limit: $limit
      offset: $offset
    ) {
      ...UserListInfoShared
    }
  }
  ${UserListInfoShared}
`;
